import React from 'react';
import { Link } from 'react-router-dom';
import {
  exhibitionLiveStatus,
  exhibitionStatusLabel,
  formatExhibitionBannerDates,
  formatScheduleDatePill,
} from './exhibitionsDisplay';
import { HOME_COPY_DEFAULTS } from './content/pageCopyDefaults';

/**
 * Top-of-home strip: next upcoming show (API returns upcoming sorted by start date ascending).
 */
export default function HomeNextExhibitionBanner({ upcoming, homeCopy = {} }) {
  const next = upcoming?.[0];
  if (!next) return null;

  const badgeLabel = homeCopy.next_exhibition_badge || HOME_COPY_DEFAULTS.next_exhibition_badge;
  const ctaLabel = homeCopy.next_exhibition_cta_label || HOME_COPY_DEFAULTS.next_exhibition_cta_label;

  const title = next.title?.trim();
  const where = [next.venue, [next.city, next.country].filter(Boolean).join(', ')].filter(Boolean).join(' · ');
  const when = formatExhibitionBannerDates(next.event_start, next.event_end);
  const pill = formatScheduleDatePill(next.event_start, next.event_end);
  const status = exhibitionLiveStatus(next);
  const statusLabel = exhibitionStatusLabel(status);

  return (
    <aside className="home-next-exhibition" aria-label="Next exhibition">
      <div className="home-next-exhibition__inner">
        <div className="home-next-exhibition__date-pill" aria-hidden="true">
          <time dateTime={next.event_start}>
            <span className="home-next-exhibition__date-month">{pill.month}</span>
            <span className="home-next-exhibition__date-day">{pill.day}</span>
          </time>
        </div>

        <div className="home-next-exhibition__content">
          <div className="home-next-exhibition__labels">
            <span className="home-next-exhibition__badge">{badgeLabel}</span>
            {statusLabel ? (
              <span className={`home-next-exhibition__status home-next-exhibition__status--${status}`}>
                {statusLabel}
              </span>
            ) : null}
          </div>
          <div className="home-next-exhibition__text">
            {title ? <p className="home-next-exhibition__title">{title}</p> : null}
            <p className="home-next-exhibition__line">
              <time className="home-next-exhibition__date" dateTime={next.event_start}>
                {when}
              </time>
              {where ? (
                <>
                  <span className="home-next-exhibition__sep" aria-hidden="true">
                    ·
                  </span>
                  <span className="home-next-exhibition__where">{where}</span>
                </>
              ) : null}
            </p>
          </div>
        </div>

        <Link to="/exhibitions" className="home-next-exhibition__cta btn btn-sm">
          {ctaLabel}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </Link>
      </div>
    </aside>
  );
}
